import { useSelector } from "react-redux";
import { CLAIMABLE_ITEMS } from "../constants/claims";

export const UseCompanyClaims = () => {
  const items = useSelector((state) => state.claimsReducer.claims);
  return items;
};

export const UseUnclaimedCount = () => {
  const items = useSelector((state) => state.claimsReducer.claims);
  const kpis = useSelector((state) => state.kpiReducer.groupKpis);

  if(kpis?.length) {
    const hasClaimableItems = kpis.reduce((has, item) => CLAIMABLE_ITEMS.includes(item.type) || has, false);
    if(hasClaimableItems) {
      // `item.kpi` is an array of claim records. An item is unclaimed when it has
      // no kpi entries or none of them carry an ownerId. Admin-dismissed reviews
      // (claimable === false) are excluded. This must mirror the Claims page
      // "Unclaimed" tab filter so the sidebar badge matches the list.
      const unclaimedItems = items.filter((item) =>
        item.claimable !== false &&
        (!Array.isArray(item.kpi) || !item.kpi.some((k) => k?.ownerId)),
      );
      return unclaimedItems?.length || 0;
    }
  }
  return 0;

}